export default __webpack_public_path__ + "static/media/Bitcoin Cash.fe34314d.svg";